import {SurveySelectionConditionModel, SurveySelectionModel} from "../model/SurveySelectionModel";
import {SurveySelectionListOptions} from "../model/SurveySelectionListOptions";
import {DataProvider} from "../../../services/intf/DataProvider";
import {ListResult} from "../../../model/ListResult";

export class SurveySelectionConditionDataProvider implements DataProvider<SurveySelectionConditionModel, SurveySelectionListOptions> {
    model: SurveySelectionModel;

    constructor(model: SurveySelectionModel) {
        this.model = model;
    }

    async delete(id: string): Promise<void> {
        const index = this.model.conditions.findIndex((x) => x.id == Number(id));
        if (index >= 0) {
            this.model.conditions.splice(index, 1);
        }
    }

    async getByID(id: string): Promise<SurveySelectionConditionModel> {
        const res = this.model.conditions.find((x) => x.id == Number(id));
        if (!res)
            throw new Error(`${id} not found`);
        return res;
    }

    async insert(data: SurveySelectionConditionModel): Promise<SurveySelectionConditionModel> {
        this.model.conditions.push({...data, id:this.model.conditions.length + 1});
        return this.model.conditions[this.model.conditions.length - 1];
    }

    async list(options: SurveySelectionListOptions): Promise<SurveySelectionConditionModel[]> {
        return this.model.conditions.map((x, index) => {
            x.id = index;
            return x;
        });
    }

    async update(id: string, item: SurveySelectionConditionModel): Promise<SurveySelectionConditionModel> {
        const res = this.model.conditions.find((x) => x.id == Number(id));
        Object.assign(res, item);
        return item;
    }

    keyProperty: string = "id";

    applyFilter(options: SurveySelectionListOptions, filter: any): SurveySelectionListOptions {
        return options;
    }
}